

































































import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    data() {
        return {
            //  Track the loading state
            loading: false,
            //  The sms numbers available to register
            numbers: null,
            //  The selected local areacode
            selectedAreacode: null,
            //  The selected sms number
            selectedNumber: null,
            //  The current step of the stepper
            step: 1
        }
    },
    mounted() {
        //  If the nexmo account does NOT exist, fetch it
        if (!this.smsAccount) this.$store.dispatch('smsAccountGet')
    },
    computed: {
        ...mapGetters(['smsAccount'])
    },
    methods: {
        goBack(): void {
            //  Reset the selectedNumber
            this.selectedNumber = null

            //  Go to step 1
            this.step = 1
        },
        popAreaCodeInfo(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Supported Area Codes',
                text: 'Some area codes might not have any phone numbers presently available for us to give you, so in the off chance that happens we will provide you with a list of random phone numbers.',
                icon: 'mdi-phone',
                color: 'primary'
            })
        },
        reset(): void {
            //  Reset the form
            this.selectedNumber = null
            this.selectedAreacode = null

            //  Reset the validator
            this.$validator.reset()
        },
        async registerNumber(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Validate the form
            const valid = await this.$validator.validate()

            //  Stop the loading spinner
            this.loading = false

            //  If the form is NOT valid, no nothing
            if (!valid) return

            //  Our payload which changes based on provider
            const payload = { msisdn: this.selectedNumber }

            //  Register the selected sms number
            const number = await this.$store.dispatch(
                'availableNumbersProvision',
                payload
            )

            //  If the number does NOT exist, do nothing
            if (!number) return

            //  If tenant has a call forwarding number, update their new number with their existing call forwarding number
            if (this.smsAccount.call_forwarding_number) {
                this.$store.dispatch('smsAccountForward', {
                    num: this.smsAccount.call_forwarding_number
                })
            }

            //  Refresh the tenant's nexmo account
            await this.$store.dispatch('smsAccountGet')

            //  Reset the form
            this.reset()

            //  Emit completion to the parent component (we use 'submit' here since this component if often hosted in the DialogApp.vue)
            this.$emit('submit', number)
        },
        async searchNumbers(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Fetch available sms number from the API
            const numbers = await this.$store.dispatch(
                'availableNumbersGet',
                this.selectedAreacode
            )

            //  If numbers do NOT exist, do nothing
            if (!numbers) return

            //  Else, set numbers
            this.numbers = numbers

            //  Advance to step 2
            this.step = 2
        }
    }
})
